import { render, staticRenderFns } from "./TransferFund.vue?vue&type=template&id=5522e0db&scoped=true"
import script from "./TransferFund.vue?vue&type=script&lang=js"
export * from "./TransferFund.vue?vue&type=script&lang=js"
import style0 from "./TransferFund.vue?vue&type=style&index=0&id=5522e0db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5522e0db",
  null
  
)

export default component.exports